import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceYear(props) {
    const formRef = useRef(null)

    const [datalist, setDatalist] = useState([]);
    const [dataitem, setDataitem] = useState({
        datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
        year: 0,
        co2: 0,
        none_purchase: 0,
        none_purchase_approve: 0,
        disable: false,
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function init_item() {
        setDataitem({
            datetimestamp: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
            year: 0,
            co2: 0,
            none_purchase: 0,
            none_purchase_approve: 0,
            disable: false,
        })
    }

    useEffect(() => {
        api_load()
        return () => {
            setDatalist([])
            setDataitem({})
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading yearly reference list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refyear/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.yearref !== null && response.data.yearref !== undefined) {
                    setDatalist(response.data.yearref)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_edit() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing a yearly reference in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('datetimestamp', dataitem.year)
            formData.append('co2', dataitem.co2)
            formData.append('none_purchase', dataitem.none_purchase)
            formData.append('none_purchase_approve', dataitem.none_purchase_approve)
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refyear/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your yearly reference has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.yearref !== null && response.data.yearref !== undefined) {
                        setDatalist(response.data.yearref)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> Yearly Reference</h4>
                                    <p className="mb-0">Manage all parameter of yearly reference</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Yearly Reference Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Year</th>
                                        <th>CO<sub>2</sub> Factor (kgCO<sub>2</sub>)</th>
                                        <th>Edit Time</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role === "Admin" ?
                                                    <th className="text-center action-fixwidth" style={{ width: "100px" }}>Action</th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.datetimestamp}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.year}</td>
                                                <td>{data.co2.toFixed(2)}</td>
                                                <td>{data.edittime}</td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role === "Admin" ?
                                                            <td>
                                                                <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered" title="Edit"
                                                                    onClick={() => {
                                                                        setDataitem({
                                                                            datetimestamp: data.datetimestamp,
                                                                            year: data.year,
                                                                            co2: data.co2,
                                                                            none_purchase: data.none_purchase,
                                                                            none_purchase_approve: data.none_purchase_approve,
                                                                            disable: true
                                                                        })
                                                                        setModal_item(true)
                                                                    }}
                                                                ><i className="fas fa-pen"></i></Link>
                                                            </td>
                                                            :
                                                            null
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> Edit Yearly Reference</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="year">Year (YYYY)</label>
                                                                <input type="text" className="form-control" name="year" value={dayjs(new Date(dataitem.datetimestamp)).format('YYYY')} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="co2">CO<sub>2</sub> Factor (kgCO<sub>2</sub>)</label>
                                                                <input type="number" className="form-control" name="co2" min={1} max={100} step={0.01} value={dataitem.co2} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        co2: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_edit() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceYear